import { render, staticRenderFns } from "./Step2.vue?vue&type=template&id=aae30300&scoped=true&"
import script from "./Step2.vue?vue&type=script&lang=tsx&"
export * from "./Step2.vue?vue&type=script&lang=tsx&"
import style0 from "./Step2.vue?vue&type=style&index=0&id=aae30300&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae30300",
  null
  
)

export default component.exports